<nav
  (mouseout)="onMouseLeaveSidenav()"
  (mouseover)="onMouseEnterSidenav()"
  class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
  id="sidenav-main"
>
  <ng-scrollbar>
    <div class="scrollbar-inner">
      <div class="sidenav-header d-flex align-items-center">
        <a [routerLink]="['/']" class="navbar-brand">
          <img
            alt="..."
            class="navbar-brand-img"
            src="https://i0.wp.com/womenfundarmenia.org/wp-content/uploads/2021/05/NHC-logo.png?fit=527%2C205&ssl=1"
          />
        </a>
        <div >
          <div
            (click)="minimizeSidebar()"
            class="sidenav-toggler d-none d-xl-block"
            data-action="sidenav-unpin"
            data-target="#sidenav-main"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="navbar-inner">
        <h6 class="navbar-heading p-0 text-muted">Portal</h6>
      </div> -->
      <div class="navbar-inner">
        <div class="collapse navbar-collapse" id="sidenav-collapse-main">
          <!-- Collapse header -->
          <ul class="navbar-nav">
            <li *ngFor="let menuitem of menuItems" class="nav-item">
              <!--If is a single link-->
              <a
                *ngIf="menuitem.type === 'link'"
                [routerLink]="[menuitem.path]"
                class="nav-link"
                routerLinkActive="active"
              >
                <!-- Font Awesome Icons -->
                <i *ngIf="!menuitem.icontype.startsWith('custom-icon')" class="ni {{ menuitem.icontype }}"></i>

                <!-- Custom SVG Icon -->
                <ng-container *ngIf="menuitem.icontype === 'custom-icon-applications'">
                  <ng-container *ngIf="menuitem.icontype === 'custom-icon-applications'">
                    <img class="bar-icon"
                      src="../../../assets/img/icons/handshake.svg"
                      alt="Handshake Icon"
                    />
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="menuitem.icontype === 'custom-icon-organization'">
                  <ng-container *ngIf="menuitem.icontype === 'custom-icon-organization'">
                    <img class="bar-icon"
                         src="../../../assets/img/icons/Organisation.svg"
                         alt="org Icon"
                    />
                  </ng-container>

                </ng-container>
                <ng-container *ngIf="menuitem.icontype === 'custom-icon-doc'">
                  <ng-container *ngIf="menuitem.icontype === 'custom-icon-doc'">
                    <img class="bar-icon"
                         src="../../../assets/img/icons/documents.svg"
                         alt="document Icon"
                    />
                  </ng-container>

                </ng-container>
                <ng-container *ngIf="menuitem.icontype === 'custom-icon-faq'">
                  <ng-container *ngIf="menuitem.icontype === 'custom-icon-faq'">
                    <img class="bar-icon"
                         src="../../../assets/img/icons/help-faq.svg"
                         alt="document Icon"
                    />
                  </ng-container>

                </ng-container>
                <ng-container *ngIf="menuitem.icontype === 'custom-icon-project'">
                  <svg
                    class="pa-di pa-dh pa-lh"
                    fill="none"
                    focusable="false"
                    height="800px"
                    role="presentation"
                    viewBox="0 0 24 24"
                    width="800px"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 14.5C20.5 14.376 19.6851 14.3714 19 14.376C18.7709 14.3775 18.9094 14.3678 18.6 14.376C17.7926 14.4012 17.0016 14.7368 17 15.6875C16.9982 16.7004 18 17 19 17C20 17 21 17.2312 21 18.3125C21 19.1251 20.1925 19.4812 19.1861 19.5991C18.3861 19.5991 18 19.625 17 19.5M19 20V21M19 13V14M3 12H14M3 12C3 16.9706 7.02944 21 12 21M3 12C3 7.02944 7.02944 3 12 3M12 21C12.338 21 12.6717 20.9814 13 20.9451M12 21C4.75561 13.08 8.98151 5.7 12 3M12 3C15.9187 3 19.2524 5.50442 20.4879 9M12 3C13.3399 4.19853 14.9177 6.31924 15.6246 9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      xmlns="http://www.w3.org/2000/svg"
                    ></path>
                  </svg>
                </ng-container>

                <span class="nav-link-text">{{ menuitem.title }}</span>
              </a>
              <!--If it have a submenu-->
              <a
                (click)="menuitem.isCollapsed = !menuitem.isCollapsed"
                *ngIf="menuitem.type === 'sub'"
                [attr.aria-controls]="menuitem.collapse"
                [attr.aria-expanded]="!menuitem.isCollapsed"
                class="nav-link"
                data-toggle="collapse"
                routerLinkActive="active"
              >
                <i class="ni {{ menuitem.icontype }}"></i>
                <span class="nav-link-text">{{ menuitem.title }}</span>
              </a>

              <!--Display the submenu items-->
              <div
                *ngIf="menuitem.type === 'sub'"
                [collapse]="menuitem.isCollapsed"
                [isAnimated]="true"
                class="collapse"
                id="{{ menuitem.collapse }}"
              >
                <ul class="nav nav-sm flex-column">
                  <li
                    *ngFor="let childitems of menuitem.children"
                    class="nav-item"
                  >
                    <!--If is a single link-->
                    <a
                      *ngIf="childitems.type === 'link'"
                      [routerLink]="[menuitem.path, childitems.path]"
                      class="nav-link"
                      routerLinkActive="active"
                    >
                      {{ childitems.title }}
                    </a>
                    <!--If it have a submenu-->
                    <a
                      (click)="childitems.isCollapsed = !childitems.isCollapsed"
                      *ngIf="childitems.type === 'sub'"
                      [attr.aria-controls]="childitems.collapse"
                      [attr.aria-expanded]="!childitems.isCollapsed"
                      class="nav-link"
                      data-toggle="collapse"
                    >
                      {{ childitems.title }}
                    </a>
                    <!--Display the submenu items-->
                    <div
                      *ngIf="childitems.type === 'sub'"
                      [collapse]="childitems.isCollapsed"
                      [isAnimated]="true"
                      class="collapse"
                      id="{{ childitems.collapse }}"
                    >
                      <ul class="nav">
                        <li
                          *ngFor="let childitem of childitems.children"
                          class="nav-item"
                        >
                          <a class="nav-link" href="javascript:void(0)">
                            {{ childitem.title }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </ng-scrollbar>

</nav>
